module.exports = __webpack_public_path__ + "static/media/samsung.e9bb6a9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samsung.svg
// module id = 111
// module chunks = 0